import envValues from '../enviornment';

export const SERVER_URL = `${envValues.REACT_APP_API_ENDPOINT}/auth`;
export const SERVER_BASE_URL = envValues.REACT_APP_API_ENDPOINT;
export const ERROR_MESSAGE = 'Api Fetch Error!';
export const ENCRYPT_SECERET_KEY = 'armia-secret-key@123';
export const REACT_APP_API_POST_USER = `${envValues.REACT_APP_API_ENDPOINT}/user`;
export const REACT_APP_API_FETCH_USER = `${envValues.REACT_APP_API_ENDPOINT}/appuser?`;
export const REACT_APP_API_FETCH_EMPLOYEE = `${envValues.REACT_APP_API_ENDPOINT}/employee?active=true&`;
export const REACT_APP_API_FETCH_ROLE = `${envValues.REACT_APP_API_ENDPOINT}/roles?active=true&`;
export const REACT_APP_API_SKILLS = `${envValues.REACT_APP_API_ENDPOINT}/dummy/selectdata`;
export const REACT_APP_API_ROLES_DROPDOWN = `${envValues.REACT_APP_API_ENDPOINT}/roles/select`;
export const REACT_APP_API_FETCH_MOVIES = `${envValues.REACT_APP_API_ENDPOINT}/movies?active=true&`;
export const REACT_APP_API_FETCH_NOTIFICATIONS = `${envValues.REACT_APP_API_ENDPOINT}/admin-notification/read-notifications?`;

export const REACT_APP_API_FETCH_APPUSER = `${envValues.REACT_APP_API_ENDPOINT}/appuser?`;
export const REACT_APP_API_FETCH_NOT_VERIFIED_USER = `${envValues.REACT_APP_API_ENDPOINT}/appuser/not-verified?`;
export const REACT_APP_API_FETCH_MINDFUL_CONTENT= `${envValues.REACT_APP_API_ENDPOINT}/mindful?`;
export const REACT_APP_API_FETCH_GRATITUDE_CONTENT= `${envValues.REACT_APP_API_ENDPOINT}/gratitude?populate=user&`;
export const REACT_APP_API_FETCH_SUBSCRIBED_USERS= `${envValues.REACT_APP_API_ENDPOINT}/subscriptions?`;
export const REACT_APP_API_FETCH_TRANSACTIONS= `${envValues.REACT_APP_API_ENDPOINT}/transactions?`;
export const REACT_APP_API_MARK_ALL_NOTIFICATIONS= `${envValues.REACT_APP_API_ENDPOINT}/admin-notification/mark-all-read?`;
export const REACT_APP_API_FETCH_INQUIRIES= `${envValues.REACT_APP_API_ENDPOINT}/inquiries?`;
export const REACT_APP_API_FETCH_REPORTS= `${envValues.REACT_APP_API_ENDPOINT}/community/reports?`;
export const REACT_APP_API_GET_REPORT_BY_ID= `${envValues.REACT_APP_API_ENDPOINT}/community/reports`;
export const REACT_APP_API_DISMISS_REPORT= `${envValues.REACT_APP_API_ENDPOINT}/community/reports`;
export const REACT_APP_API_RESOLVE_REPORT= `${envValues.REACT_APP_API_ENDPOINT}/community/reports`;
export const REACT_APP_API_DELETE_POST= `${envValues.REACT_APP_API_ENDPOINT}/community/posts`;
export const REACT_APP_API_DELETE_COMMENT= `${envValues.REACT_APP_API_ENDPOINT}/community/comments`;
export const REACT_APP_API_BLOCK_USER= `${envValues.REACT_APP_API_ENDPOINT}/community/users`;
export const REACT_APP_API_UNBLOCK_USER= `${envValues.REACT_APP_API_ENDPOINT}/community/users`;



